export function createBucketStore({ storage, key, allowed, prefix = '' } = {}) {
  const STORAGE = storage ?? window.localStorage;
  const fullKey = prefix ? prefix + key : key;

  const safeJsonParse = (raw, fallback) => {
    try {
      return raw ? JSON.parse(raw) : fallback;
    } catch {
      return fallback;
    }
  };

  const createBucket = () => Object.fromEntries(allowed.map((k) => [k, []]));

  const load = () => {
    const base = createBucket();
    const data = safeJsonParse(STORAGE.getItem(fullKey), base);

    // 키 누락/오염 방지
    for (const k of allowed) {
      if (!Array.isArray(data?.[k])) data[k] = [];
    }
    return data;
  };

  const save = (items) => STORAGE.setItem(fullKey, JSON.stringify(items));

  return {
    key: fullKey,
    allowed,
    items: null,

    init() {
      this.items = load();
    },

    add(type, name) {
      const t = String(type || '')
        .trim()
        .toLowerCase();
      const n = String(name || '').trim();
      if (!t || !n) return;
      if (!this.allowed.includes(t)) return;

      const list = this.items[t];
      if (!list.includes(n)) list.push(n);
      save(this.items);
      this.items = { ...this.items };
    },

    remove(type, name) {
      const t = String(type || '')
        .trim()
        .toLowerCase();
      const n = String(name || '').trim();
      if (!t || !n) return;
      if (!this.allowed.includes(t)) return;

      this.items[t] = this.items[t].filter((x) => x !== n);
      save(this.items);
      this.items = { ...this.items };
    },

    clear(type) {
      if (type) {
        const t = String(type).trim().toLowerCase();
        if (!this.allowed.includes(t)) return;
        this.items[t] = [];
      } else {
        this.items = createBucket();
      }
      save(this.items);
      this.items = { ...this.items };
    },

    remove(type, name) {
      const t = String(type || '')
        .trim()
        .toLowerCase();
      const n = String(name || '').trim();
      if (!t || !n) return;
      if (!this.allowed.includes(t)) return;

      this.items[t] = this.items[t].filter((x) => x !== n);
      save(this.items);

      // ✅ Alpine 반응성 확실히
      this.items = { ...this.items };
    },

    get totalCount() {
      // 전체 아이템 수 집계
      if (!this.items) return 0;

      return Object.values(this.items).reduce((sum, list) => {
        return sum + (Array.isArray(list) ? list.length : 0);
      }, 0);
    },

    // 선택: 토큰 파싱까지 공통 제공
    addToken(token) {
      if (typeof token !== 'string') return;
      const idx = token.indexOf(':');
      if (idx <= 0) return;
      const t = token.slice(0, idx).trim().toLowerCase();
      const n = token.slice(idx + 1).trim();
      this.add(t, n);
    },
  };
}
